/**
 * A full-page error message to show when the user attempts to access something
 * that they don't have permission to see.
 */
import {t} from "@lingui/core/macro";
import * as React from "react";

import NotFound from "@repo/component-screens/not-found";

import PageDisplay from "#data-access/page-display.tsx";

import DefaultPageTemplate from "../page-templates/default-page-template.tsx";

import {withStrings} from "./locales/not-found/load-strings.tsx";

type Props = {
    resetSettings?: boolean;
};

function NotFoundPage({resetSettings}: Props): React.ReactElement {
    return (
        <DefaultPageTemplate>
            <PageDisplay
                resetSettings={resetSettings}
                settings={{
                    headerBackgroundColor: "darkBlue",
                    title: t`Page not found`,
                    statusCode: 404,
                }}
            >
                <NotFound />
            </PageDisplay>
        </DefaultPageTemplate>
    );
}

export default withStrings(NotFoundPage);
